import { render, staticRenderFns } from "./host-set-label.vue?vue&type=template&id=6b883c48&scoped=true&"
import script from "./host-set-label.vue?vue&type=script&lang=js&"
export * from "./host-set-label.vue?vue&type=script&lang=js&"
import style0 from "./host-set-label.vue?vue&type=style&index=0&id=6b883c48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b883c48",
  null
  
)

export default component.exports